let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8pCmI")).then(() => parcelRequire('7RqM0'));